module.exports = __webpack_public_path__ + "static/img/banner.0bd8f88d.jpg";